import React from 'react';

// Types
import { GoalItem } from 'Shared/constants/types';

// Components
import HistoryItem from './HistoryItem';

type Props = {
  goal: GoalItem;
};

const GoalHistory = ({ goal }: Props) => {
  const history = Object.values(goal.history);

  return (
    <div className="GoalHistory">
      {history.reverse().map(item => (
        <HistoryItem key={`${item.timestamp}-${item.changeType}`} history={item} />
      ))}
    </div>
  );
};

export default GoalHistory;
